"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ong(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9824 19.9916C16.2874 19.9916 19.5484 17.1071 20.2249 13.3331H16.5521C16.0031 15.3371 14.2991 16.8041 12.0259 16.8041C9.76915 16.8041 8.0434 15.3266 7.47115 13.3331H3.77515C4.4269 17.1206 7.66015 19.9916 11.9824 19.9916Z", fill: color }),
        React.createElement("path", { d: "M12.0033 7.79892C13.0501 7.79892 13.8986 6.95039 13.8986 5.90367C13.8986 4.85696 13.0501 4.00842 12.0033 4.00842C10.9566 4.00842 10.1081 4.85696 10.1081 5.90367C10.1081 6.95039 10.9566 7.79892 12.0033 7.79892Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.26636 13.3331V13.2956C7.26636 10.6009 9.19686 8.40112 11.9801 8.40112C14.7641 8.40112 16.7351 10.6384 16.7396 13.3331H7.26636Z", fill: color }));
}
exports["default"] = ong;
//# sourceMappingURL=ong.js.map